module.exports = __webpack_public_path__ + "static/img/6.6c8cbf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/6.png
// module id = 28rp
// module chunks = 0